import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';

const MIN_PASSWORD_LENGTH = 8;

/** Form shape includes confirm; mutation payload is normalized via mapper. */
export type ResetPasswordFormValues = {
  newPassword: string;
  confirmPassword: string;
};

const resetPasswordFormSchema = z
  .object({
    newPassword: z
      .string()
      .min(MIN_PASSWORD_LENGTH, `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`),
    confirmPassword: z.string().min(1, 'Confirm your new password.'),
  })
  .refine(value => value.newPassword === value.confirmPassword, {
    message: 'Passwords do not match.',
    path: ['confirmPassword'],
  });

export class ResetPasswordDataValidator implements Validator<ResetPasswordFormValues> {
  readonly standardSchema = resetPasswordFormSchema;

  validate(value: unknown): Result<ResetPasswordFormValues, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Invalid reset-password payload.',
        ),
      );
    }

    return ok(parsed.data);
  }
}
